import { forwardRef, Icon, IconProps } from '@chakra-ui/react';

const KotlinColor = forwardRef<IconProps, 'svg'>((props, ref) => (
  <Icon ref={ref} viewBox="0 0 16 16" {...props}>
    <svg width="16" height="16" viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg">
      <g id="Size=16px">
        <path id="kotlin-color" d="M15 15H1V1H15L8 7.9972L15 15Z" fill="url(#paint0_linear_3494_1085)" />
      </g>
      <defs>
        <linearGradient
          id="paint0_linear_3494_1085"
          x1="14.9987"
          y1="0.998498"
          x2="0.995792"
          y2="14.9958"
          gradientUnits="userSpaceOnUse"
        >
          <stop offset="0.00343514" stopColor="#E44857" />
          <stop offset="0.4689" stopColor="#C711E1" />
          <stop offset="1" stopColor="#7F52FF" />
        </linearGradient>
      </defs>
    </svg>
  </Icon>
));

export default KotlinColor;
